import { Badge } from '../ui/badge'
import { Entity } from '../../hooks/use-memories'
import { User, MapPin, Lightbulb, Building2, Calendar, Package, HelpCircle } from 'lucide-react'

interface EntityBadgeProps {
  entity: Entity
  onClick?: () => void
}

const entityTypeIcons = {
  person: User,
  place: MapPin,
  concept: Lightbulb,
  organisation: Building2,
  event: Calendar,
  object: Package,
  other: HelpCircle,
}

const entityTypeColors = {
  person: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  place: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  concept: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
  organisation: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
  event: 'bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-200',
  object: 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200',
  other: 'bg-slate-100 text-slate-800 dark:bg-slate-900 dark:text-slate-200',
}

export function EntityBadge({ entity, onClick }: EntityBadgeProps) {
  const Icon = entityTypeIcons[entity.entity_type as keyof typeof entityTypeIcons] || HelpCircle
  const colorClass = entityTypeColors[entity.entity_type as keyof typeof entityTypeColors] || entityTypeColors.other

  return (
    <Badge
      variant="secondary"
      className={`${colorClass} cursor-pointer hover:opacity-80 transition-opacity flex items-center gap-1`}
      onClick={onClick}
    >
      <Icon className="h-3.5 w-3.5" />
      <span>{entity.name}</span>
      {entity.relationship_type !== 'mentions' && (
        <span className="text-xs opacity-75">({entity.relationship_type})</span>
      )}
    </Badge>
  )
}

